import { render, staticRenderFns } from "./TasksManager.vue?vue&type=template&id=ff406e36&"
import script from "./TasksManager.vue?vue&type=script&lang=js&"
export * from "./TasksManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports